"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _gsap = require("gsap");

var _reactTransitionGroup = require("react-transition-group");

var _propTypes = require("prop-types");

var _ramda = require("ramda");

var _easing = _interopRequireDefault(require("../easing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var propTypes = {
  alwaysShowInDom: _propTypes.bool,
  children: _propTypes.node,
  className: _propTypes.string,
  clearProps: _propTypes.string,
  delayIn: _propTypes.number,
  delayOut: _propTypes.number,
  easing: _propTypes.func,
  enterDuration: _propTypes.number,
  exitDuration: _propTypes.number,
  fadeInOut: _propTypes.bool,
  horizontal: _propTypes.number,
  show: _propTypes.bool,
  showAnimation: _propTypes.bool,
  vertical: _propTypes.number
};

var SlideIn = function SlideIn(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$clearProps = _ref.clearProps,
      clearProps = _ref$clearProps === void 0 ? "display,x,y" : _ref$clearProps,
      _ref$delayIn = _ref.delayIn,
      delayIn = _ref$delayIn === void 0 ? 0 : _ref$delayIn,
      _ref$delayOut = _ref.delayOut,
      delayOut = _ref$delayOut === void 0 ? 0 : _ref$delayOut,
      _ref$easing = _ref.easing,
      easing = _ref$easing === void 0 ? ["Power4", "easeOut"] : _ref$easing,
      _ref$enterDuration = _ref.enterDuration,
      enterDuration = _ref$enterDuration === void 0 ? 0.25 : _ref$enterDuration,
      _ref$exitDuration = _ref.exitDuration,
      exitDuration = _ref$exitDuration === void 0 ? 0.2 : _ref$exitDuration,
      _ref$fadeInOut = _ref.fadeInOut,
      fadeInOut = _ref$fadeInOut === void 0 ? false : _ref$fadeInOut,
      _ref$alwaysShowInDom = _ref.alwaysShowInDom,
      alwaysShowInDom = _ref$alwaysShowInDom === void 0 ? true : _ref$alwaysShowInDom,
      _ref$vertical = _ref.vertical,
      vertical = _ref$vertical === void 0 ? 1 : _ref$vertical,
      _ref$horizontal = _ref.horizontal,
      horizontal = _ref$horizontal === void 0 ? 0 : _ref$horizontal,
      show = _ref.show,
      _ref$showAnimation = _ref.showAnimation,
      showAnimation = _ref$showAnimation === void 0 ? true : _ref$showAnimation;
  return /*#__PURE__*/_react["default"].createElement(_reactTransitionGroup.Transition, {
    appear: true,
    className: className,
    enter: showAnimation,
    exit: showAnimation,
    "in": showAnimation && show,
    mountOnEnter: !alwaysShowInDom,
    onEnter: function onEnter(node) {
      _gsap.TweenLite.set(node, {
        display: "inherit",
        opacity: 1,
        x: "0%",
        y: "0%"
      });

      _gsap.TweenLite.from(node, enterDuration, {
        delay: delayIn,
        ease: (0, _ramda.path)(easing, _easing["default"]),
        opacity: fadeInOut ? 0 : 1,
        x: horizontal * 100 + "%",
        y: vertical * 100 + "%"
      });
    },
    onExit: function onExit(node) {
      _gsap.TweenLite.to(node, exitDuration, {
        clearProps: alwaysShowInDom ? clearProps : "none",
        delay: delayOut,
        ease: (0, _ramda.path)(easing, _easing["default"]),
        opacity: fadeInOut ? 0 : 1,
        x: horizontal * 100 + "%",
        y: vertical * 100 + "%"
      });
    },
    timeout: {
      enter: (enterDuration + delayIn) * 1000,
      exit: (exitDuration + delayOut) * 1000
    },
    unmountOnExit: !alwaysShowInDom
  }, children);
};

SlideIn.propTypes = propTypes;
var _default = SlideIn;
exports["default"] = _default;